export function getBulkDiscountsForTicketType(bulkDiscounts = [], ticketTypeId) {
  return bulkDiscounts.filter(discount => {
    return (
      discount.quantityCondition === 'ticketTypeQuantity' &&
      discount.ticketTypes.includes(ticketTypeId)
    );
  });
}
